<template>
  <div class="md-layout" id="university-criterion-index">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title base-index-title">{{ title }}</h4>
          <md-card-actions class="text-right md-alignment-right btn-index-add">
            <router-link :to="{ name: 'CriterionCreateForm' }">
              <md-button native-type="submit" class="md-primary"
                >{{ $t("common.add") }}
              </md-button>
            </router-link>
          </md-card-actions>
        </md-card-header>
        <md-card-content>
          <base-search-form
            :formSearch="formSearch"
            @search="changePage"
            @exportExcel="exportExcel"
            :enableExport="enableExport"
          />
          <base-table
            :tableData="tableData"
            :pagination="pagination"
            :columns="columns"
            @confirmDelete="confirmDelete"
            :hideAction="hideAction"
          />
        </md-card-content>
        <base-pagination :pagination="pagination" @changePage="changePage" />
      </md-card>
    </div>
  </div>
</template>

<script>
import {
  BasePagination,
  BaseTable,
  BaseSearchForm
} from "@/components/Base/index.js";

import Swal from "sweetalert2";
import { ExportService } from "../../../services/export.service";
import formatDateTime from "@/core/utils/formatTime";
import { CriterionService } from "../../../services/criterion.service";

export default {
  name: "CriterionIndex",
  data() {
    return {
      pagination: {
        perPage: 10,
        from: 0,
        to: 0,
        total: 0,
        currentPage: 0
      },
      tableData: [],
      params: {},
      modal: {
        show: false,
        action: "view"
      },
      modalAdd: {
        show: false
      }
    };
  },
  props: [
    "path",
    "formSearch",
    "columns",
    "enableExport",
    "title",
    "hideAction",
    "serviceName"
  ],
  components: { BaseTable, BasePagination, BaseSearchForm },
  mounted() {
    this.getTableData();
  },
  methods: {
    async getTableData() {
      const response = await new CriterionService().getList(this.params);

      let tableData = response.data;
      tableData.forEach(function(criterion) {
        criterion.created_at = criterion.created_at
          ? formatDateTime(criterion.created_at)
          : "";
        criterion.updated_at = criterion.updated_at
          ? formatDateTime(criterion.updated_at)
          : "";
        criterion.criterion_category_name = criterion.criterion_category
          ? criterion.criterion_category.name
          : "";
      });
      this.tableData = tableData;
      this.pagination.perPage = response.per_page;
      this.pagination.currentPage = response.current_page;
      this.pagination.total = response.total;
      this.pagination.from = response.from;
      this.pagination.to = response.to;
      return this.tableData;
    },
    changePage(params) {
      this.params.page = this.pagination.currentPage;
      this.params.limit = this.pagination.perPage;
      this.params = { ...this.params, ...params };
      this.getTableData();
    },
    closeModal() {
      this.modal.show = false;
      this.modalAdd.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    async delete(id) {
      const response = await new CriterionService().delete(id);
      if (!response) {
        return;
      }
      await Swal.fire({
        title: "Deleted!",
        text: `You deleted ${id}`,
        type: "success",
        confirmButtonClass: "md-button md-success btn-fill",
        buttonsStyling: false
      });
      // Reload table data
      await this.getTableData();
    },
    confirmDelete(data) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.delete(data.id);
        }
      });
    },
    notify(message, type = "success", title = "Notification") {
      this.$notify({
        message: message,
        type: type,
        title: title,
        text: message
      });
    },
    exportExcel() {
      ExportService.exportExcel(this.path, this.params);
    }
  },
  computed: {
    currentRoutePath() {
      return this.$route.path;
    }
  }
};
</script>
<style scoped>
.md-card .md-card-actions {
  border: none;
  margin-top: 15px;
}
</style>
